import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-multi-selection',
  templateUrl: './multi-selection.component.html',
  styleUrls: ['./multi-selection.component.scss']
})
export class MultiSelectionComponent implements OnInit {
  @Input() appendTo: string;
  @Input() items: Array<any>;
  @Input() bindValue: string;
  @Input() bindLabel: string;
  @Input() fieldName: string;
  @Input() selectedValues;
  @Input() groupBy: string | Function;
  @Input() selectableGroup = false;
  @Input() selectableGroupAsModel = true;
  @Input() selectedOptionWidth = 0;
  @Input() disabled = false;
  @Output() change = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void { }

  filterSelect() {
    this.change.emit({
      field: this.fieldName,
      value: this.selectedValues
    });
  }
}
